import { Component, OnInit } from '@angular/core';
import { ReceiptService } from 'src/app/services/autopac/receipt.service';
import { FormField } from 'src/app/interfaces/form-field.model';
import { faPencil, faTrash, faPlus, faPrint, faBan, faEnvelope } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css']
})
export class ReceiptComponent implements OnInit {

  constructor(private receiptService: ReceiptService) {}

  faPencil = faPencil;
  faTrash = faTrash;
  faPlus = faPlus;
  faPrint = faPrint;
  faBan = faBan;
  faEnvelope = faEnvelope;

  lastSearchResult: any = null;

  allTerminalOptions: { display: string; value: string }[] = [];

  selectedTab: string = 'buyers';

  isTransfer: boolean = false;

  showTransferSection: boolean = false;

  showDeleteModal = false;
  deleteRemarks = '';

  searchForm: FormField[] = [
    {
      type: 'select',
      id: 'searchCriteria',
      label: 'Search criteria',
      options: [
        { display: 'Buyer Order Number', value: 'BuyerOrderNumber' },
        { display: 'Contract Number', value: 'ContractNumber' },
        { display: 'Cheque Number', value: 'ChequeNumber' },
        { display: 'Receipt Number', value: 'ReceiptNumber' }
      ],
      value: 'BuyerOrderNumber',
    },
    {
      type: 'search',
      id: 'searchText',
      label: 'Text to search',
      searchEvent: true, 
      searchType: "searchBuyersReceipt", 
    },
    {
      type: 'text',
      id: 'RefNo',
      label: 'Buyer Order Number',
      lock: true,
    },
    {
      type: 'text',
      id: 'ContractNo',
      label: 'Contract Number',
      lock: true,
    },
    {
      type: 'text',
      id: 'ChequeNumber',
      label: 'Cheque Number',
      lock: true,
    },
    {
      type: 'text',
      id: 'ReceiptNo',
      label: 'Receipt Number',
      lock: true,
    },
  ];

  transferReceiptForm: FormField[] = [
    { type: 'text', id: 'TransferToBuyerOrder', label: "Transfer To Buyer's Order:" },
    { type: 'text', id: 'Remarks', label: 'Remarks:' }
  ];
  
  buyerDetailsForm: FormField[] = [
    { type: 'text', id: 'contractDate', label: 'Contract Date', lock: true, },
    { type: 'text', id: 'refNo', label: "Buyer's Order Number", lock: true, },
    { type: 'text', id: 'invoiceDate', label: 'Invoice Date', lock: true, },
    { type: 'text', id: 'invoiceNumber', label: 'Invoice Number', lock: true, },
    { type: 'text', id: 'mobileNumber', label: 'Mobile Number', lock: true, },
    { type: 'text', id: 'name', label: 'Name', lock: true, },
    { type: 'text', id: 'salesConsultant', label: 'Sales Consultant', lock: true, },
    { type: 'text', id: 'address', label: 'Address', lock: true, }
  ];

  buyerReceiptForm: FormField[] = [
    { type: 'text', id: 'previousReceiptNumber', label: 'Previous Receipt Number' },
    { type: 'date', id: 'receiptDate', label: 'Receipt Date (dd/mm/yyyy)' },
    { type: 'date', id: 'transactionDate', label: 'Transaction Date (dd/mm/yyyy)' },
    {
      type: 'select',
      id: 'paymentType',
      label: 'Payment Type',
      options: [
        { display: 'PARF', value: 'PARF' },
        { display: 'COE Deposit', value: 'COE Deposit' },
        { display: 'Customer', value: 'Customer' }
      ]
    },
    {
      type: 'select',
      id: 'paymentMode',
      label: 'Payment Mode',
      options: [
        { display: 'CREDIT CARD', value: 'CREDIT CARD' },
        { display: 'CHEQUE', value: 'CHEQUE' },
        { display: 'GIRO', value: 'GIRO' },
        { display: 'TT', value: 'TT' },
        { display: 'NETS', value: 'NETS' },
        { display: 'AMEX', value: 'AMEX' },
        { display: 'CASH', value: 'CASH' },
        { display: "CASHIER'S ORDER", value: "CASHIER'S ORDER" },
        { display: 'ONLINE CREDIT CARD', value: 'ONLINE CREDIT CARD' },
        { display: 'PAYNOW', value: 'PAYNOW' },
        { display: 'OTHERS', value: 'OTHERS' }
      ]
    },
    { type: 'text', id: 'issuer', label: 'Issuer' },
    { type: 'text', id: 'bank', label: 'Bank' },
    { type: 'text', id: 'chequeNumber', label: 'Cheque Number' },
    {
      type: 'select',
      id: 'terminalNumber',
      label: 'Terminal Number',
      options: []
    },
    { type: 'text', id: 'batchNumber', label: 'Batch Number' },
    { type: 'text', id: 'invoiceNumber', label: 'Invoice Number' },
    { type: 'text', id: 'description', label: 'Description' },
    { type: 'text', id: 'amount', label: 'Amount' },
    { type: 'text', id: 'amountInWords', label: 'Amount in words', lock: true },
    {
      type: 'select',
      id: 'status',
      label: 'Status',
      options: [
        { display: 'Please select', value: '' },
        { display: 'Banked', value: 'Banked' },
        { display: 'Re-Banked', value: 'Re-Banked' },
        { display: 'Cleared', value: 'Cleared' },
        { display: 'Cheque Returned', value: 'Cheque Returned' }
      ],
      //value: 'Banked',
    },
    { type: 'text', id: 'totalPayment', label: 'Total Payment' },
  ];

  tableReceiptHeaders = [
    { title: 'CONTRACT NUMBER', type: 'data', id: 'ContractNo' },
    { title: 'RECEIPT NUMBER', type: 'data', id: 'ReceiptNo' },
    { title: 'RECEIPT DATE', type: 'data', id: 'ReceiptDate' },
    { title: "BUYER'S NRIC", type: 'data', id: 'Nric' },
    { title: "BUYER'S NAME", type: 'data', id: 'Name' },
    { title: 'PAYMENT TYPE', type: 'data', id: 'PaymentType' },
    { title: 'AMOUNT', type: 'data', id: 'Amount' },
    { title: 'STATUS', type: 'data', id: 'Status' },
    { title: 'INVOICE NUMBER', type: 'data', id: 'InvoiceNumber' },
    { title: "BUYER'S ORDER NUMBER", type: 'data', id: 'RefNo' },
    { title: 'ACTION', type: 'edit' }
  ];
  
  tableReceiptEntries: any[] = [];
  
  depositSearchForm: FormField[] = [
    {
      type: 'select',
      id: 'searchBy',
      label: 'Search by',
      options: [
        { display: 'Contract Number', value: 'ContractNumber' },
        { display: 'Buyer Order Number', value: 'BuyerOrderNumber' }
      ],
      value: 'ContractNumber'
    },
    {
      type: 'search',
      id: 'searchText',
      label: 'Search', 
      searchEvent: true, 
      searchType: "searchDeposit", 
    },
    {
      type: 'text',
      id: 'ContractNumber',
      label: 'Contract Number',
      lock: true,
    },
    {
      type: 'text',
      id: 'BuyerOrderNumber',
      label: "Buyer's Order Number",
      lock: true,
    }
  ];
  
  depositBuyerDetailsForm: FormField[] = [
    { type: 'text', id: 'ContractDate', label: 'Contract Date', lock: true, },
    { type: 'text', id: 'BuyerOrderDate', label: "Buyer's Order Date", lock: true, },
    { type: 'text', id: 'Nric', label: 'NRIC No/RCB No/Passport No', lock: true, },
    { type: 'text', id: 'Name', label: 'Name', lock: true, },
    { type: 'text', id: 'Mobile', label: 'Mobile Number', lock: true,  },
    { type: 'text', id: 'Address', label: 'Address', lock: true,  },
    { type: 'text', id: 'SalesConsultant', label: 'Sales Consultant', lock: true, }
  ];
  
  depositSummaryForm: FormField[] = [
    { type: 'text', id: 'TotalDepositPayment', label: 'Total Deposit Payment', lock: true, }
  ];
  
  depositTableHeaders = [
    { title: 'CONTRACT NUMBER', type: 'data' },
    { title: "BUYER'S ORDER NUMBER", type: 'data' },
    { title: 'RECEIPT NUMBER', type: 'data' },
    { title: 'INVOICE NUMBER', type: 'data' },
    { title: 'RECEIPT DATE', type: 'data' },
    { title: "BUYER'S NRIC", type: 'data' },
    { title: "BUYER'S NAME", type: 'data' },
    { title: 'PAYMENT TYPE', type: 'data' },
    { title: 'AMOUNT', type: 'data' },
    { title: 'STATUS', type: 'data' },
    { title: 'DESCRIPTION', type: 'data' },
  ];
  
  depositTableEntries: any[] = []; 
  
  ngOnInit(): void {
    this.receiptService.getTerminalList().subscribe(response => {
      const terminals = response?.body || [];
      const terminalOptions = terminals.map((term: any) => ({
        display: term,
        value: term
      }));
  
      /*const terminalField = this.buyerReceiptForm.find(f => f.id === 'terminalNumber');
      if (terminalField) terminalField.options = terminalOptions;*/

      this.receiptService.getTerminalList().subscribe((res) => {
        const terminals = res?.body || [];
        const terminalOptions = terminals.map((t: any) => ({
          display: `${t.TerminalNo} (${t.Branch})`,
          value: t.TerminalNo.toString()
        }));
      
        const terminalField = this.buyerReceiptForm.find(f => f.id === 'terminalNumber');
        if (terminalField) terminalField.options = terminalOptions;
      });     
    });

    this.receiptService.getTerminalList().subscribe((res) => {
      const terminals = res?.body || [];
      this.allTerminalOptions = terminals.map((t: any) => ({
        display: `${t.TerminalNo} (${t.Branch})`,
        value: t.TerminalNo.toString()
      }));
    
      const terminalField = this.buyerReceiptForm.find(f => f.id === 'terminalNumber');
      if (terminalField) terminalField.options = [...this.allTerminalOptions];
    });
    
  }
  
  updateSearchReceipt(event: any): void {
    console.log("hola");
  }

  updateDetails(event: any): void {
    const paymentModeField = this.buyerReceiptForm.find(f => f.id === 'paymentMode');
    const terminalField = this.buyerReceiptForm.find(f => f.id === 'terminalNumber');
    const bankField = this.buyerReceiptForm.find(f => f.id === 'bank');
  
    const paymentMode = paymentModeField?.value;
  
    if (!paymentMode || !terminalField) return;
  
    let allowedBranches: string[] = [];
  
    switch (paymentMode.toUpperCase()) {
      case 'CREDIT CARD':
        allowedBranches = ['MANUAL', 'ALEX', 'BT', 'TSB SVC'];
        break;
      case 'NETS':
        allowedBranches = ['ALEX', 'BT'];
        break;
      case 'AMEX':
        allowedBranches = ['ALEX', 'MANUAL'];
        break;
      default:
        allowedBranches = [];
    }
  
    if (allowedBranches.length > 0) {
      terminalField.options = this.allTerminalOptions.filter(option => {
        const branchMatch = option.display.match(/\((.*?)\)/);
        const branch = branchMatch ? branchMatch[1].toUpperCase() : '';
        return allowedBranches.includes(branch);
      });
    } else {
      terminalField.options = [...this.allTerminalOptions];
    }
  
    if (bankField) {
      switch (paymentMode.toUpperCase()) {
        case 'AMEX':
          bankField.value = 'AMEX';
          break;
        case 'CHEQUE':
        case 'GIRO':
        case 'TT':
        case 'CASH':
        case "CASHIER'S ORDER":
        case 'ONLINE CREDIT CARD':
        case 'PAYNOW':
        case 'OTHERS':
          bankField.value = 'CASH';
          break;
      }
    }
  
    this.toggleBuyerReceiptFieldsVisibility(paymentMode.toUpperCase());

    const amountField = this.buyerReceiptForm.find(f => f.id === 'amount');
    const amountInWordsField = this.buyerReceiptForm.find(f => f.id === 'amountInWords');

    const amount = Number(amountField?.value);
    if (!isNaN(amount) && amountInWordsField) {
      amountInWordsField.value = this.numberToWords(amount);
    }

    this.calculateTotalPayment();

  }
  
  searchBuyers(event: any): void {
    const searchCriteria = this.searchForm.find(f => f.id === 'searchCriteria')?.value;
    const searchText = this.searchForm.find(f => f.id === 'searchText')?.value;
  
    if (!searchCriteria || !searchText) return;
  
    const mappedCriteria = this.mapSearchCriteria(searchCriteria);
  
    this.receiptService.getReceiptBySearch(searchText, mappedCriteria).subscribe(response => {
      const result = response?.body;
      this.lastSearchResult = result;
  
      console.log('Search response:', result);
  
      if (result?.Receipt) {
        const receipt = result.Receipt;
      
        const searchMap = {
          BuyerOrder: 'BuyerOrder',
          ContractNumber: 'ContractNo',
          ChequeNumber: 'ChequeNumber',
          ReceiptNumber: 'ReceiptNo',
        };
      
        const buyerDetailsMap = {
          contractDate: 'ContractDate',
          invoiceDate: 'InvoiceDate',
          mobileNumber: 'MobileNumber',
          salesConsultant: 'SalesConsultant',
          buyerOrderNumber: 'BuyerOrder',
          invoiceNumber: 'InvoiceNo',
          name: 'Name',
          address: 'Address',
          refNo: 'RefNo',
        };
      
        const buyerReceiptMap = {
          previousReceiptNumber: 'PreviousReceiptNo',
          receiptDate: 'ReceiptDate',
          transactionDate: 'TransactionDate',
          paymentType: 'PaymentType',
          paymentMode: 'PaymentMode',
          issuer: 'Issuer',
          bank: 'Bank',
          chequeNumber: 'ChequeNumber',
          batchNumber: 'BatchNumber',
          invoiceNumber: 'InvoiceNo',
          description: 'Description',
          amount: 'Amount',
          status: 'Status',
          totalPayment: 'TotalPayment',
        };
      
        this.searchForm.forEach(field => {
          const mappedKey = searchMap[field.id as keyof typeof searchMap];
          if (mappedKey) field.value = receipt[mappedKey] ?? '';
        });
      
        this.buyerDetailsForm.forEach(field => {
          const mappedKey = buyerDetailsMap[field.id as keyof typeof buyerDetailsMap];
          if (mappedKey) field.value = receipt[mappedKey] ?? '';
        });
      
        this.buyerReceiptForm.forEach(field => {
          const mappedKey = buyerReceiptMap[field.id as keyof typeof buyerReceiptMap];
          if (field.id === 'invoiceNumber') return;
          if (mappedKey) {
            if (['receiptDate', 'transactionDate'].includes(field.id)) {
              field.value = this.formatDateToInput(receipt[mappedKey]) ?? '';
            } else {
              field.value = receipt[mappedKey] ?? '';
            }
          }
        });

        const searchFormMap = {
          RefNo: 'RefNo',
          ContractNo: 'ContractNo',
          ChequeNumber: 'ChequeNumber',
          ReceiptNo: 'ReceiptNo',
        };
        
        this.searchForm.forEach(field => {
          const mappedKey = searchFormMap[field.id as keyof typeof searchFormMap];
          if (mappedKey) {
            field.value = receipt[mappedKey] ?? '';
          }
        });
        
      }
      
      if (result?.ReceiptList?.length) {
        this.tableReceiptEntries = result.ReceiptList.map((entry: any) => ({
          ContractNo: entry.ContractNo,
          ReceiptNo: entry.ReceiptNo,
          ReceiptDate: entry.ReceiptDate,
          Nric: entry.Nric,
          Name: entry.Name,
          PaymentType: entry.PaymentType,
          Amount: entry.Amount,
          Status: entry.Status,
          InvoiceNumber: entry.InvoiceNumber,
          RefNo: entry.RefNo,
          edit: '',
        }));
      }     
  
      this.receiptService.getLastReceiptNo().subscribe(last => {
        const lastNo = last?.body;
        console.log('Last Receipt No:', lastNo);

        const previousReceiptField = this.buyerReceiptForm.find(f => f.id === 'previousReceiptNumber');
        if (previousReceiptField) previousReceiptField.value = lastNo;
      });
    });
  }
  
  mapSearchCriteria(criteria: string): string {
    switch (criteria) {
      case 'BuyerOrderNumber': return 'BuyerOrderNo';
      case 'ContractNumber': return 'ContractNo';
      case 'ChequeNumber': return 'ChequeNo';
      case 'ReceiptNumber': return 'ReceiptNo';
      default: return '';
    }
  }  
  
  searchDeposit(event: any): void {
    const searchBy = this.depositSearchForm.find(f => f.id === 'searchBy')?.value;
    const searchText = this.depositSearchForm.find(f => f.id === 'searchText')?.value;
  
    if (!searchBy || !searchText) return;
  
    const mappedCriteria = searchBy === 'ContractNumber' ? 'ContractNo' : 'BuyerOrderNo';
  
    this.receiptService.searchDeposit(searchText, mappedCriteria).subscribe(response => {
      const data = response?.body;
      console.log('Search Deposit Response:', data);
  
      const receipt = data?.Receipt;
      if (receipt) {
        const depositMap = {
          ContractDate: 'ContractDate',
          BuyerOrderDate: 'BuyerOrderDate',
          Nric: 'Nric',
          Mobile: 'MobileNo',
          SalesConsultant: 'SalesConsultant',
          BuyerOrderNumber: 'BuyerOrderNo',
          Name: 'Name',
          Address: 'Address'
        };
  
        this.depositBuyerDetailsForm.forEach(field => {
          const key = depositMap[field.id as keyof typeof depositMap];
          if (key) field.value = receipt[key] ?? '';
        });
  
        const contractField = this.depositSearchForm.find(f => f.id === 'ContractNumber');
        const buyerOrderField = this.depositSearchForm.find(f => f.id === 'BuyerOrderNumber');
        if (contractField) contractField.value = receipt.ContractNo ?? '';
        if (buyerOrderField) buyerOrderField.value = receipt.BuyerOrderNo ?? '';
  
        const totalDepositField = this.depositSummaryForm.find(f => f.id === 'TotalDepositPayment');
        if (totalDepositField) totalDepositField.value = receipt.TotalDeposit ?? 0;
      }
  
      const receiptList = data?.ReceiptList ?? [];
      this.depositTableEntries = receiptList.map((entry: any) => ({
        ContractNo: entry.ContractNo,
        RefNo: entry.RefNo,
        ReceiptNo: entry.ReceiptNo,
        InvoiceNumber: entry.InvoiceNumber,
        ReceiptDate: entry.ReceiptDate,
        Nric: entry.Nric,
        Name: entry.Name,
        PaymentType: entry.PaymentType,
        Amount: entry.Amount,
        Status: entry.Status,
        Description: entry.Description
      }));
    });
  }
  
  transferReceipt(): void {
    const receiptNo = this.searchForm.find(f => f.id === 'ReceiptNo')?.value ?? '';
    const transferTo = this.transferReceiptForm.find(f => f.id === 'TransferToBuyerOrder')?.value ?? '';
    const remarks = this.transferReceiptForm.find(f => f.id === 'Remarks')?.value ?? '';
  
    if (!receiptNo || !transferTo) {
      alert("Please enter both Receipt Number and Transfer To Buyer's Order.");
      return;
    }
  
    const payload = {
      ReceiptNo: receiptNo,
      TransferContractNo: transferTo,
      TransferRemarks: remarks
    };
  
    this.receiptService.transferReceipt(payload).subscribe({
      next: (res) => {
        const message = res?.body?.Message ?? 'Transfer completed.';
        alert(message);
  
        this.searchBuyers(null);
        this.showTransferSection = false;
        this.isTransfer = false;
  
        this.transferReceiptForm.forEach(f => f.value = '');
      },
      error: (err) => {
        const message = err?.error?.body?.Message ?? 'Error occurred during transfer.';
        alert(message);
      }
    });
  }
  

  cancelTransferReceipt(): void {
    this.isTransfer = false;
    this.showTransferSection = false;
  }    

  addReceipt(): void {
    const getFromForm = (form: FormField[], id: string) => form.find(f => f.id === id)?.value ?? null;
  
    const receiptForm = this.buyerReceiptForm;
    const buyerForm = this.buyerDetailsForm;
    const searchForm = this.searchForm;
  
    const capitalizeWords = (text: string) =>
      text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  
    const rawPaymentMode = getFromForm(receiptForm, 'paymentMode') ?? '';
    const paymentMode = capitalizeWords(rawPaymentMode);
  
    const hiddenIf = (fieldId: string) => {
      const upper = paymentMode.toUpperCase();
      if (['CREDIT CARD', 'NETS', 'AMEX'].includes(upper)) return false;
      if (['CHEQUE', 'GIRO', 'TT', "CASHIER'S ORDER", 'PAYNOW', 'OTHERS'].includes(upper)) {
        return ['terminalNumber', 'batchNumber', 'invoiceNumber'].includes(fieldId);
      }
      if (upper === 'CASH') {
        return ['chequeNumber', 'terminalNumber', 'batchNumber', 'invoiceNumber'].includes(fieldId);
      }
      if (upper === 'ONLINE CREDIT CARD') {
        return ['chequeNumber', 'terminalNumber'].includes(fieldId);
      }
      return false;
    };
  
    const tableNric = this.tableReceiptEntries?.[0]?.Nric ?? null;
  
    const getFormattedDate = (form: FormField[], id: string) => {
      const val = getFromForm(form, id);
      if (!val || !val.includes('-')) return null;
      const [year, month, day] = val.split('-');
      return `${day}/${month}/${year}`;
    };
  
    const payload = {
      __type: "KAPS.Model.CrmSalesmanReceipt",
      ReceiptNo: getFromForm(searchForm, 'ReceiptNo'),
      ContractNo: getFromForm(searchForm, 'ContractNo'),
      ContractDate: getFromForm(buyerForm, 'contractDate'),
      RefNo: getFromForm(buyerForm, 'refNo'),
      InvoiceDate: getFromForm(buyerForm, 'invoiceDate'),
      InvoiceNo: getFromForm(buyerForm, 'invoiceNo'),
      Nric: tableNric,
      Name: getFromForm(buyerForm, 'name'),
      MobileNumber: getFromForm(buyerForm, 'mobileNumber'),
      Address: getFromForm(buyerForm, 'address'),
      SalesConsultant: getFromForm(buyerForm, 'salesConsultant'),
      PreviousReceiptNo: getFromForm(receiptForm, 'previousReceiptNumber'),
      ReceiptDate: getFormattedDate(receiptForm, 'receiptDate'),
      TransactionDate: getFormattedDate(receiptForm, 'transactionDate'),
      PaymentType: getFromForm(receiptForm, 'paymentType'),
      PaymentMode: paymentMode,
      Issuer: getFromForm(receiptForm, 'issuer'),
      Bank: getFromForm(receiptForm, 'bank'),
      Description: getFromForm(receiptForm, 'description'),
      Amount: Number(getFromForm(receiptForm, 'amount')) || 0,
      AmountInWords: getFromForm(receiptForm, 'amountInWords'),
      TotalPayment: Number(getFromForm(receiptForm, 'totalPayment')) || 0,
      Status: getFromForm(receiptForm, 'status'),
      ChequeNumber: hiddenIf('chequeNumber') ? "" : getFromForm(receiptForm, 'chequeNumber'),
      TerminalNumber: null,
      TerminalNo: hiddenIf('terminalNumber') ? null : Number(getFromForm(receiptForm, 'terminalNumber')),
      BatchNumber: hiddenIf('batchNumber') ? null : getFromForm(receiptForm, 'batchNumber'),
      InvoiceNumber: hiddenIf('invoiceNumber') ? null : getFromForm(receiptForm, 'invoiceNumber'),
      CancelReason: null,
      CustomerCode: null
    };
  
    this.receiptService.addReceipt(payload).subscribe({
      next: (res) => {
        const message = res?.body?.Message ?? 'Unknown server response';
        alert(message);
    
        if (res?.body?.Code === 0) {
          this.searchBuyers(null);
          this.receiptService.getLastReceiptNo().subscribe(last => {
            const lastNo = last?.body;
            const previousReceiptField = this.buyerReceiptForm.find(f => f.id === 'previousReceiptNumber');
            if (previousReceiptField) previousReceiptField.value = lastNo;
          });
        }
      },
      error: (err) => {
        console.error('Error adding receipt:', err);
        const message = err?.error?.Message || err?.message || 'An unexpected error occurred.';
        alert(message);
      }
    });
    
  }
  
  updateReceipt(): void {
    const getFromForm = (form: FormField[], id: string) => form.find(f => f.id === id)?.value ?? null;
  
    const receiptForm = this.buyerReceiptForm;
    const buyerForm = this.buyerDetailsForm;
    const searchForm = this.searchForm;
  
    const receiptField = searchForm.find(f => f.id === 'ReceiptNo');
    const receiptNo = receiptField?.value;
  
    if (!receiptNo) {
      alert('Please enter receipt number!');
      return;
    }
  
    const capitalizeWords = (text: string) =>
      text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  
    const rawPaymentMode = getFromForm(receiptForm, 'paymentMode') ?? '';
    const paymentMode = capitalizeWords(rawPaymentMode);
  
    const hiddenIf = (fieldId: string) => {
      const upper = paymentMode.toUpperCase();
      if (['CREDIT CARD', 'NETS', 'AMEX'].includes(upper)) return false;
      if (['CHEQUE', 'GIRO', 'TT', "CASHIER'S ORDER", 'PAYNOW', 'OTHERS'].includes(upper)) {
        return ['terminalNumber', 'batchNumber', 'invoiceNumber'].includes(fieldId);
      }
      if (upper === 'CASH') {
        return ['chequeNumber', 'terminalNumber', 'batchNumber', 'invoiceNumber'].includes(fieldId);
      }
      if (upper === 'ONLINE CREDIT CARD') {
        return ['chequeNumber', 'terminalNumber'].includes(fieldId);
      }
      return false;
    };
  
    const tableNric = this.tableReceiptEntries?.[0]?.Nric ?? null;
  
    const getFormattedDate = (form: FormField[], id: string) => {
      const val = getFromForm(form, id);
      if (!val || !val.includes('-')) return null;
      const [year, month, day] = val.split('-');
      return `${day}/${month}/${year}`;
    };
  
    const payload = {
      __type: "KAPS.Model.CrmSalesmanReceipt",
      ReceiptNo: receiptNo,
      ContractNo: getFromForm(searchForm, 'ContractNo'),
      ContractDate: getFromForm(buyerForm, 'contractDate'),
      RefNo: getFromForm(buyerForm, 'refNo'),
      InvoiceDate: getFromForm(buyerForm, 'invoiceDate'),
      InvoiceNo: getFromForm(buyerForm, 'invoiceNo'),
      Nric: tableNric,
      Name: getFromForm(buyerForm, 'name'),
      MobileNumber: getFromForm(buyerForm, 'mobileNumber'),
      Address: getFromForm(buyerForm, 'address'),
      SalesConsultant: getFromForm(buyerForm, 'salesConsultant'),
      PreviousReceiptNo: getFromForm(receiptForm, 'previousReceiptNumber'),
      ReceiptDate: getFormattedDate(receiptForm, 'receiptDate'),
      TransactionDate: getFormattedDate(receiptForm, 'transactionDate'),
      PaymentType: getFromForm(receiptForm, 'paymentType'),
      PaymentMode: paymentMode,
      Issuer: getFromForm(receiptForm, 'issuer'),
      Bank: getFromForm(receiptForm, 'bank'),
      Description: getFromForm(receiptForm, 'description'),
      Amount: Number(getFromForm(receiptForm, 'amount')) || 0,
      AmountInWords: getFromForm(receiptForm, 'amountInWords'),
      TotalPayment: Number(getFromForm(receiptForm, 'totalPayment')) || 0,
      Status: getFromForm(receiptForm, 'status'),
      ChequeNumber: hiddenIf('chequeNumber') ? null : getFromForm(receiptForm, 'chequeNumber'),
      TerminalNumber: null,
      TerminalNo: hiddenIf('terminalNumber') ? null : Number(getFromForm(receiptForm, 'terminalNumber')),
      BatchNumber: hiddenIf('batchNumber') ? null : getFromForm(receiptForm, 'batchNumber'),
      InvoiceNumber: hiddenIf('invoiceNumber') ? null : getFromForm(receiptForm, 'invoiceNumber'),
      CancelReason: null,
      CustomerCode: null
    };
  
    console.log('Update payload:', payload);
  
    this.receiptService.updateReceipt(payload).subscribe({
      next: (res) => {
        const message = res?.body?.Message ?? 'Unknown response';
        alert(message);
        this.searchBuyers(null);
        this.receiptService.getLastReceiptNo().subscribe(last => {
          const lastNo = last?.body;
          const previousReceiptField = this.buyerReceiptForm.find(f => f.id === 'previousReceiptNumber');
          if (previousReceiptField) previousReceiptField.value = lastNo;
        });
      },
      error: (err) => {
        console.error('Error updating receipt:', err);
        const fallback = err?.error?.d?.Message || err?.message || 'Unknown error';
        alert(fallback);
      }
    });
  }
  
  deleteReceipt(): void {
    const receiptNo = this.searchForm.find(f => f.id === 'ReceiptNo')?.value ?? '';
    if (!receiptNo) {
      alert('Please enter Receipt Number!');
      return;
    }
  
    this.showDeleteModal = true;
  }

  confirmDeleteReceipt(): void {
    const receiptNo = this.searchForm.find(f => f.id === 'ReceiptNo')?.value ?? '';
    if (!receiptNo) return;
  
    this.receiptService.deleteReceipt(receiptNo, this.deleteRemarks).subscribe({
      next: (res) => {
        const msg = res?.body?.Message ?? 'Receipt deleted.';
        alert(msg);
        this.showDeleteModal = false;
        this.searchBuyers(null);
        this.receiptService.getLastReceiptNo().subscribe(last => {
          const lastNo = last?.body;
          const previousField = this.buyerReceiptForm.find(f => f.id === 'previousReceiptNumber');
          if (previousField) previousField.value = lastNo;
        });
      },
      error: (err) => {
        const msg = err?.error?.body?.Message ?? 'Error deleting receipt.';
        alert(msg);
      }
    });
  }

  cancelDelete(): void {
    this.deleteRemarks = '';
    this.showDeleteModal = false;
  }
  
  printReceipt(): void {
    const receiptNo = this.searchForm.find(f => f.id === 'ReceiptNo')?.value ?? '';
  
    if (!receiptNo) {
      alert('Please enter a Receipt Number before printing.');
      return;
    }
  
    this.receiptService.printReceipt(receiptNo).subscribe({
      next: (res) => {
        const pdfUrl = res?.body?.Name;
        if (pdfUrl) {
          window.open(pdfUrl, '_blank');
        } else {
          alert('No file was generated.');
        }
      },
      error: (err) => {
        const msg = err?.error?.body?.Message ?? 'Error printing receipt.';
        alert(msg);
      }
    });
  }
  
  clearReceipt(): void {
    const clearForm = (form: FormField[]) => {
      form.forEach(field => {
        if ('value' in field) field.value = '';
      });
    };
  
    clearForm(this.searchForm);
    clearForm(this.buyerDetailsForm);
    clearForm(this.buyerReceiptForm);
    clearForm(this.transferReceiptForm);
  
    this.tableReceiptEntries = [];
    this.isTransfer = false;
    this.showTransferSection = false;
  
    const previousReceiptField = this.buyerReceiptForm.find(f => f.id === 'previousReceiptNumber');
    if (previousReceiptField) previousReceiptField.value = '';
  }  

  sendReceiptEmail(): void {
    const receiptNo = this.searchForm.find(f => f.id === 'ReceiptNo')?.value ?? '';
  
    if (!receiptNo) {
      alert('Please enter a Receipt Number before sending email.');
      return;
    }
  
    this.receiptService.sendReceiptEmail(receiptNo).subscribe({
      next: (res) => {
        const message = res?.body?.Message ?? 'Email sent successfully.';
        alert(message);
      },
      error: (err) => {
        const msg = err?.error?.body?.Message ?? 'Error sending receipt email.';
        alert(msg);
      }
    });
  }  

  editReceipt(entry: any): void {
    const selectedReceipt = this.lastSearchResult?.ReceiptList?.find(
      (r: any) => r.ReceiptNo === entry.ReceiptNo
    );
  
    if (!selectedReceipt) return;
  
    const buyerReceiptMap = {
      receiptDate: 'ReceiptDate',
      transactionDate: 'TransactionDate',
      paymentType: 'PaymentType',
      paymentMode: 'PayType',
      issuer: 'Issuer',
      bank: 'Bank',
      chequeNumber: 'ChequeNumber',
      terminalNumber: 'TerminalNumber',
      batchNumber: 'BatchNumber',
      invoiceNumber: 'InvoiceNumber',
      description: 'Description',
      amount: 'Amount',
      status: 'Status'
    };
  
    let paymentModeValue = selectedReceipt.PayType?.toUpperCase() ?? '';
    const terminalField = this.buyerReceiptForm.find(f => f.id === 'terminalNumber');
  
    if (terminalField) {
      let allowedBranches: string[] = [];
  
      switch (paymentModeValue) {
        case 'CREDIT CARD':
          allowedBranches = ['MANUAL', 'ALEX', 'BT', 'TSB SVC'];
          break;
        case 'NETS':
          allowedBranches = ['ALEX', 'BT'];
          break;
        case 'AMEX':
          allowedBranches = ['ALEX', 'MANUAL'];
          break;
        default:
          allowedBranches = [];
      }
  
      if (allowedBranches.length > 0) {
        terminalField.options = this.allTerminalOptions.filter(option => {
          const branchMatch = option.display.match(/\((.*?)\)/);
          const branch = branchMatch ? branchMatch[1].toUpperCase() : '';
          return allowedBranches.includes(branch);
        });
      } else {
        terminalField.options = [...this.allTerminalOptions];
      }
    }
  
    this.buyerReceiptForm.forEach(field => {
      const key = buyerReceiptMap[field.id as keyof typeof buyerReceiptMap];
      if (!key) return;
  
      let value = selectedReceipt[key];
  
      if (['receiptDate', 'transactionDate'].includes(field.id)) {
        if (value) {
          const [day, month, year] = value.split('/');
          value = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
      }
  
      if (field.id === 'terminalNumber') {
        const match = field.options?.find(o => o.value === value?.toString());
        field.value = match?.value ?? '';
      } else if (field.id === 'paymentMode') {
        const match = field.options?.find(o => o.value.toLowerCase() === value?.toLowerCase());
        field.value = match?.value ?? '';
      } else {
        field.value = value ?? '';
      }
    });
  
    const receiptNoField = this.searchForm.find(f => f.id === 'ReceiptNo');
    if (receiptNoField) receiptNoField.value = selectedReceipt.ReceiptNo ?? '';
  
    this.toggleBuyerReceiptFieldsVisibility(paymentModeValue);

    const amountInWordsField = this.buyerReceiptForm.find(f => f.id === 'amountInWords');
    const amount = Number(selectedReceipt.Amount);
    if (!isNaN(amount) && amountInWordsField) {
      amountInWordsField.value = this.numberToWords(amount);
    }

  }
  
  formatDateToInput(value: string): string {
    if (!value || !value.includes('/')) return '';
    const [day, month, year] = value.split('/');
    return `${year}-${month}-${day}`;
  }  

  toggleBuyerReceiptFieldsVisibility(paymentMode: string): void {
    const hiddenFieldsMap: { [key: string]: string[] } = {
      'CHEQUE': ['terminalNumber', 'batchNumber', 'invoiceNumber'],
      'GIRO': ['terminalNumber', 'batchNumber', 'invoiceNumber'],
      'TT': ['terminalNumber', 'batchNumber', 'invoiceNumber'],
      "CASHIER'S ORDER": ['terminalNumber', 'batchNumber', 'invoiceNumber'],
      'PAYNOW': ['terminalNumber', 'batchNumber', 'invoiceNumber'],
      'OTHERS': ['terminalNumber', 'batchNumber', 'invoiceNumber'],
      'CASH': ['chequeNumber', 'terminalNumber', 'batchNumber', 'invoiceNumber'],
      'ONLINE CREDIT CARD': ['chequeNumber', 'terminalNumber'],
    };
  
    const fieldsToHide = hiddenFieldsMap[paymentMode] ?? [];
  
    this.buyerReceiptForm.forEach(field => {
      field.show = !fieldsToHide.includes(field.id);
    });
  }
  
  handleTransferToggle(): void {
    const receiptField = this.searchForm.find(f => f.id === 'ReceiptNo');
  
    if (this.isTransfer && !receiptField?.value) {
      alert('Please input Receipt Number to Transfer!');
      setTimeout(() => {
        this.isTransfer = false;
      }, 0);
      this.showTransferSection = false;
      return;
    }
  
    this.showTransferSection = this.isTransfer;
  }
  
  numberToWords(n: number): string {
    const a = [
      '', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX',
      'SEVEN', 'EIGHT', 'NINE', 'TEN', 'ELEVEN', 'TWELVE',
      'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN',
      'SEVENTEEN', 'EIGHTEEN', 'NINETEEN'
    ];
    const b = [
      '', '', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY',
      'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY'
    ];
  
    if (n === 0) return 'ZERO ONLY';
  
    const numToWords = (num: number): string => {
      if (num < 20) return a[num];
      if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
      if (num < 1000) return a[Math.floor(num / 100)] + ' HUNDRED' + (num % 100 ? ' ' + numToWords(num % 100) : '');
      if (num < 1000000) return numToWords(Math.floor(num / 1000)) + ' THOUSAND' + (num % 1000 ? ' ' + numToWords(num % 1000) : '');
      return num.toString(); // fallback
    };
  
    return numToWords(n) + ' ONLY';
  }

  calculateTotalPayment(): void {

    const receiptList = this.lastSearchResult?.ReceiptList || [];
    const amountField = this.buyerReceiptForm.find(f => f.id === 'amount');
    const totalPaymentField = this.buyerReceiptForm.find(f => f.id === 'totalPayment');
    const receiptNoField = this.searchForm.find(f => f.id === 'ReceiptNo');
  
    /*console.log("receiptList", receiptList);
    console.log("amountField", amountField);
    console.log("totalPaymentField", totalPaymentField);
    console.log("receiptNoField", receiptNoField);*/

    if (!amountField || !totalPaymentField || !receiptNoField) return;
  
    const newAmount = parseFloat(amountField.value) || 0;
    const currentReceiptNo = receiptNoField.value;
  
    let totalPayment = 0;
    let currentOriginalAmount = 0;
  
    receiptList.forEach((r: any) => {
      totalPayment += r.Amount;
      if (r.ReceiptNo === currentReceiptNo) {
        currentOriginalAmount = r.Amount;
      }
    });
  
    totalPayment = totalPayment - currentOriginalAmount + newAmount;
    totalPaymentField.value = totalPayment;
  }

  formatDateToPayload(value: string): string | null {
    if (!value || !value.includes('-')) return null;
    const [year, month, day] = value.split('-');
    return `${day}/${month}/${year}`;
  }
  
  
}
